export { EXPERTISE, ExpertiseType } from './expertise';
export { THEMATIC, ThematicType } from './thematic';
export { MEDIA_THEMATIC, MediaThematicType } from './media-thematic';
export { COMMON_THEMATIC, CommonThematicType } from './common-thematic';
export { PUBLICATION, PublicationType } from './publication';
export {
  FINANCIAL_PUBLICATION,
  FinancialPublicationType,
} from './financial-publication';
export { CATEGORY, CategoryType } from './category';
export {
  REGION,
  REGION_NATIONAL,
  REGION_INTERNATIONAL,
  RegionType,
  isNationalRegion,
  isInternationalRegion,
} from './region';
export { MENU, MenuType } from './menu';
export { CLASSIFICATION, ClassificationType } from './classification';

export const FILTER = {
  CATEGORY: 'category',
  CLASSIFICATION: 'classification',
  COMMON_THEMATIC: 'commonThematic',
  EXPERTISE: 'expertise',
  MEDIA_THEMATIC: 'mediaThematic',
  MEDIA_TYPE: 'mediaType',
  MENU: 'menu',
  PUBLICATION: 'publication',
  FINANCIAL_PUBLICATION: 'financialPublication',
  REGION: 'region',
  THEMATIC: 'thematic',
};
